import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { User as UserTypes } from 'mxp-schemas';
import { PageForgotEmail } from 'components/pages/PageForgotEmail/PageForgotEmail';
import { userErrorSelector, userLoadingSelector, userMaskedEmailSelector } from 'modules/user/selectors';
import { clearUserError, clearUserForgotEmail, getUserByAICPAIdAndLastName } from 'modules/user/actions';
import { getPath } from 'utils';
import { Routes } from 'constants/index';
import { push } from 'connected-react-router';

const mapActionCreators = (dispatch: Dispatch) => ({
  getEmail(idNumber: string, lastName: string): void {
    dispatch(getUserByAICPAIdAndLastName(parseInt(idNumber, 10), lastName)).catch(
      (rejection: State.UserError | null) => {
        if (rejection?.errorCode !== UserTypes.UserErrorCodes.LOGIN_NOT_FOUND) {
          // when error unknown
          dispatch(push(getPath(Routes.NOT_FOUND)));
        }
      }
    );
  },

  clearPreviousResults(): void {
    dispatch(clearUserError());
    dispatch(clearUserForgotEmail());
  },
});

const mapStateToProps = (state: State.Root) => ({
  loading: userLoadingSelector(state),
  error: userErrorSelector(state),
  maskedEmail: userMaskedEmailSelector(state),
});

export const PageForgotEmailContainer = connect(mapStateToProps, mapActionCreators)(PageForgotEmail);
